import React, {
	useEffect, useMemo, useRef, useState,
} from 'react';
import propTypes from 'prop-types';
import clsx from 'clsx';
import {
	List, makeStyles,
} from '@material-ui/core';
import useContain from 'react-contain-textbox';
import { useFirestoreCollectionRT } from '../hooks/firebase';
import ItemCard from './ItemCard';
import victoryWav from '../assets/victory/victory.wav';
import crownPng from '../assets/victory/crown.png';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: '0 0.5em',
		margin: 0,
	},
	crown: {
		position: 'absolute',
		top: '-1em',
		left: '0',
		width: '3em',
		transform: 'rotate(-30deg)',
	},
	row: {
		margin: 1,
		padding: 0,
		background: theme.palette.grey[100],
		borderRadius: '1em',
		paddingRight: '1em',
	},
}));

export default function Goal(props) {
	const { className } = props;
	const ref = useRef();

	const resize = useContain(ref);

	const [audio] = useState(() => new Audio(victoryWav), []);

	const classes = useStyles();
	const teams = useFirestoreCollectionRT('teams');

	useEffect(() => {
		resize();
	}, [resize, teams]);

	const teamsSorted = useMemo(() => {
		if (!teams) return [];
		return Object.entries(teams).sort((a, b) => b[1].sumDonations - a[1].sumDonations);
	}, [teams]);

	const topTeamRef = useRef();

	useEffect(() => {
		const [[tid] = []] = teamsSorted;
		const changed = topTeamRef.current && topTeamRef.current !== tid;
		topTeamRef.current = tid;

		if (!changed) return;

		audio.play();
	}, [teamsSorted, audio]);

	return (
		<List
			ref={ref}
			className={clsx(classes.root, className)}
			dense
		>
			{teams && (
				<img
					className={classes.crown}
					alt="crown"
					src={crownPng}
				/>
			)}
			{teamsSorted.map(([tid, team]) => (
				<ItemCard
					key={tid}
					className={classes.row}
					avatarUrl={team.avatarImageURL}
					title={team.name || tid}
					body={`$${team.sumDonations?.toFixed(2) || '0.00'} / $${team.fundraisingGoal?.toFixed(2) || '0.00'}`}
				/>
			))}
		</List>
	);
}

Goal.defaultProps = {
	className: undefined,
};

Goal.propTypes = {
	className: propTypes.string,
};
